import React from 'react'
import { Box, Typography, Button } from '@mui/material'

const HomeCareer = ({sx, titlesx, buttonsx}) => {
  return (
    <Box
        sx={{
            background:'',
            display:'flex',
            flexDirection:'column',
            padding:'2rem',
            width:'50%',
            marginY:'3rem',
            '@media screen and (max-width:762px)':{
                width:'70%'
            },
            ...sx
        }}
    >
        <Typography
            variant='h1'
            sx={{
                fontFamily:'var(--title-font)',
                fontSize:'2rem',
                fontWeight:'500',
                ...titlesx
            }}
        >
            Be Part of the Team
        </Typography>
        <Typography
            sx={{
                fontFamily:'var(--text-font)',
                fontSize:'1rem',
                paddingY:'1rem'
            }}
        >
            We're always looking for skilled and hardworking professionals to join our team.
            If you have experience in construction, Project Management, or Desing andis passionate about building high-quality projects, we'd love to hear from you!
        </Typography>
        <Box
            sx={{
                paddingY:'1rem'
            }}
        >
            <Button
                variant='outlined'
                href='/career'
                sx={{
                    borderColor:'#000',
                    color:'#000',
                    borderWidth:'2px',
                    borderRadius:'0',
                    ...buttonsx,
                    '&:hover':{
                        backgroundColor:'var(--color-secondary)',
                        borderColor:'var(--color-secondary)',
                        borderWidth:'2px',
                        color:'#fefefe'
                    }
                }}
            >Learn more</Button>
        </Box>
    </Box>
  )
}

export default HomeCareer